var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("ob1-select-field", {
          attrs: {
            id: "recovery-simulator-brands",
            elements: _vm.brands,
            disabled: _vm.loadingBrand,
            "place-holder": _vm.messages.brandLabel,
          },
          on: { input: _vm.onSelectBrand },
          model: {
            value: _vm.selectedBrand,
            callback: function ($$v) {
              _vm.selectedBrand = $$v
            },
            expression: "selectedBrand",
          },
        }),
        _vm._v(" "),
        _vm.loadingBrand
          ? _c("ob1-progress-indicators", {
              attrs: { size: 25, type: "undetermined" },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("ob1-select-field", {
          attrs: {
            id: "recovery-simulator-models",
            elements: _vm.models,
            disabled: _vm.selectedBrand === undefined || _vm.loadingModel,
            "place-holder": _vm.messages.modelLabel,
          },
          on: { input: _vm.onSelectModel },
          model: {
            value: _vm.selectedModel,
            callback: function ($$v) {
              _vm.selectedModel = $$v
            },
            expression: "selectedModel",
          },
        }),
        _vm._v(" "),
        _vm.loadingModel
          ? _c("ob1-progress-indicators", {
              attrs: { size: 25, type: "undetermined" },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }